/**
 * Choix du type de facturation d'une prestation (normal / urgence) en boutons segmentés (15/10/2026).
 * Usage : <TypeFacturationChoix v-model="type_facturation" :disabled="save_loading" />
 * Les types viennent du store (types_facturation_prestation, chargés par getTypesFacturationPrestation).
 */
const TYPES_DEFAUT = [{ value: 'normal' }, { value: 'urgence' }]

export default {
    name: 'type-facturation-choix',
    props: {
        value: {
            type: String,
            default: 'normal'
        },
        disabled: {
            type: Boolean,
            default: false
        },
        libelle: {
            type: String,
            default: 'Type facturation'
        }
    },

    computed: {
        options() {
            const types = this.$store.getters['types_facturation_prestation']
            return ((types && types.length) ? types : TYPES_DEFAUT).map(type => ({
                value: type.value,
                libelle: type.value.charAt(0).toUpperCase() + type.value.slice(1)
            }))
        }
    },

    methods: {
        choisir(value) {
            if (!this.disabled && value !== this.value) {
                this.$emit('input', value)
            }
        }
    }
}
